import { ICellRendererParams } from "ag-grid-community";
import { IRoute, routes } from "../../../routes/routes";
import { UIViewEnum } from "../../../common/enums/UIViewEnum";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useRouteContext } from "../../../hooks/use-route-context/UseRouteContext";
import { getDeviceRoute, getWellRoute } from "../../../common/utilities/RouteHelpers";
import useNavigateTo, { NavigateToOptions } from "../../../hooks/use-navigate-to/useNavigateTo";
import { NewViewTypeEnum } from "../../../common/enums/NewViewTypeEnum";
import useMapTo from "../../../hooks/use-map-to/useMapTo";


export type ShortcutsCellRendererProps = {
    disableNavigation?: boolean;
} & ICellRendererParams;

export default function ShortcutsCellRenderer({
    data,
    disableNavigation
}: ShortcutsCellRendererProps) {

    const routeContext = useRouteContext();
    const navigateTo = useNavigateTo();

    const mapTo = useMapTo();

    const functionIcons: IRoute[] = data?.functionIcons ?? [];


    const onLinkClicked = (viewID: UIViewEnum, shiftKey: boolean, ctrlKey: boolean) => {
        if (disableNavigation) {
            return;
        }

        if (viewID === UIViewEnum.Group_MapView) {

            const latitude = data.latitude;
            const longitude = data.longitude;
            mapTo({
                latitude, 
                longitude
            });

            return;
        }




        let options: NavigateToOptions | undefined;

        if (shiftKey || ctrlKey) {
            options = {
                newViewType: shiftKey ? NewViewTypeEnum.NewWindow : NewViewTypeEnum.NewTab
            }
        }


        const item = routes.find(o => o.viewID === viewID);

        let url: string | undefined;

        if (data?.deviceID) {

            url = getDeviceRoute(item?.viewID as UIViewEnum,
                routeContext.groupID,
                routeContext.wellID,
                data.deviceID);

            if (item?.viewID === UIViewEnum.Device_Details_History) {

                sessionStorage.setItem("addmemo", "true");
            }
        } else if (data?.wellID) {
            url = getWellRoute(item?.viewID as UIViewEnum,
                routeContext.groupID,
                data.wellID);
        }

        if (url) {
            navigateTo(url, options);
        }
    }

    return (
        functionIcons.length > 0
            ? <Box
                sx={{
                    overflow: 'hidden'
                }}
            >
                {
                    functionIcons.map((o) => (
                        <Tooltip key={o.name} title={o.name}>
                            <IconButton
                                style={{
                                    fontSize: '1em',
                                    padding: 0,
                                    marginRight: 8
                                }}
                                onClick={(ev) => onLinkClicked(o.viewID as UIViewEnum, ev.shiftKey, ev.ctrlKey)}
                            >
                                <o.icon />
                            </IconButton>
                        </Tooltip>
                    ))
                }
            </Box>
            : ""
    )
}


